import React from 'react';
import {Box,BoxProps} from '@mui/material';
import {usePrivatePhoto} from '../../hooks/usePrivatePhoto';
export default function PrivatePhoto({uri,alt,...props}:BoxProps & {uri:string;alt:string}){
 const url=usePrivatePhoto(uri);
 return url?<Box {...props} component="img" src={url} alt={alt}/>:<Box {...props} role="img" aria-label={alt}/>;
}
